import { Link } from "react-router-dom";
import { UserCheck, ShieldCheck, EyeOff, Bell } from "lucide-react";
import { useI18n } from "../../i18n";
import { Button } from "../ui/button";

// RC-WEB-1 §lote2 — marketing de Contactos de Confianza (F6 del Bloque C).
const TrustedContactsSection = () => {
  const { t } = useI18n();
  const points = [
    { icon: UserCheck, key: "delegate" },
    { icon: ShieldCheck, key: "consent" },
    { icon: EyeOff, key: "privacy" },
    { icon: Bell, key: "routing" },
  ];

  return (
    <section className="bg-white py-20 md:py-28" data-testid="trusted-contacts-marketing">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-start gap-14 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-[#1B84FF]">
              {t("tcmk.eyebrow")}
            </p>
            <h2 className="mb-5 text-3xl font-extrabold tracking-tight text-[#0B2545] sm:text-4xl lg:text-5xl">
              {t("tcmk.title")}
            </h2>
            <p className="mb-8 max-w-lg text-base text-slate-600 md:text-lg">{t("tcmk.subtitle")}</p>
            <Link to="/register">
              <Button
                className="rounded-full bg-[#0B2545] px-8 py-3 font-semibold text-white transition-transform hover:-translate-y-0.5 hover:bg-[#133763]"
                data-testid="tcmk-cta"
              >
                {t("tcmk.cta")}
              </Button>
            </Link>
          </div>

          <div className="grid gap-5 sm:grid-cols-2">
            {points.map(({ icon: Icon, key }) => (
              <div
                key={key}
                className="rounded-3xl border border-slate-200/80 bg-[#F8FAFC] p-6 transition-colors hover:border-[#1B84FF]/40 hover:bg-white"
                data-testid={`tcmk-point-${key}`}
              >
                <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-[#EAF4FF]">
                  <Icon className="h-5 w-5 text-[#1B84FF]" />
                </span>
                <h3 className="mb-1.5 font-bold text-[#0B2545]">{t(`tcmk.${key}_title`)}</h3>
                <p className="text-sm leading-relaxed text-slate-600">{t(`tcmk.${key}_text`)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedContactsSection;
